function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-5-5h24v24H-5z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h16v16H-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2276E3",
  d: "M12.808.333H1.192a.86.86 0 00-.859.859v11.616a.86.86 0 00.859.859h11.616a.86.86 0 00.859-.86V1.193a.86.86 0 00-.859-.859zm-2.027 4.358L6.89 9.97a.563.563 0 01-.794.104L3.32 7.85a.556.556 0 11.695-.868L6.34 8.844l3.549-4.813a.556.556 0 11.894.66h-.002z"
})));

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default SvgCheckboxChecked;